import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import { MuiThemeProvider } from '@material-ui/core/styles';
import themes from './lib/themes';

import AutoSizeView from './lib/components/AutoSizeView';
import Dialog from './lib/components/Dialog';
import Loading from './lib/components/Loading';
import TimeCheck from './lib/components/TimeCheck';

import InfoaddSelect from './viewers/pages/InfoaddSelect';
import Infoadd from './viewers/pages/Infoadd';
import Infoupd from './viewers/pages/Infoupd';
import InsertComplete from './viewers/pages/InsertComplete';
import UpdateComplete from './viewers/pages/UpdateComplete';

const appRoutes = ({ theme }) => (
  <MuiThemeProvider theme={themes[theme]}>
    <Dialog />
    <Loading />
    <TimeCheck />
    <Switch>
      <Route exact path="/infoaddSelect" component={InfoaddSelect} />
      <Route exact path="/infoadd" component={Infoadd} />
      <Route exact path="/insertcomplete" component={InsertComplete} />
      <Route exact path="/infoupd" component={Infoupd} />
      <Route exact path="/updatecomplete" component={UpdateComplete} />
      <Redirect to="/" component={Infoadd} />
    </Switch>
  </MuiThemeProvider>
);


const privateRoute = ({  component: Component, ...rest }) => {  
  return (
  <Route
    {...rest}
    render={props => (
      <AutoSizeView component={Component} {...props} />
      )
    }
  />
)};

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated,
  authorityList: state.auth
});

const mapStateToPropsForMui = state => ({
  theme: state.style.theme,
});

const Routes = connect(mapStateToPropsForMui)(appRoutes);
const PrivateRoute = connect(mapStateToProps)(privateRoute);

export default Routes;
